import React from 'react'
import Button from '../../components/Button'
import Hero from '../../components/Hero'
import Page from '../../components/Page'
import { Text } from '../../components/Text'
import AnnouncementsPreview from '../Announcements/AnnouncementsPreview'
import GoodNewsBanner from './GoodNewsBanner'
import Location from './Location'
import Media from './Media'
import OurActivities from './OurActivities'
import WeBelieve from './WeBelieve'

export default function Home() {
  const [locationRef, setLocationRef] = React.useState<HTMLDivElement | null>(null)
  const gotoLocation = React.useCallback(() => locationRef?.scrollIntoView(), [locationRef])
  return (
    <Page>
      <Hero
        title='THE BRETHREN ASSEMBLY'
        subtitle='DUBAI'
        button={
          <div className='flex flex-row gap-6'>
            <Button variant='default' icon='Location' onClick={gotoLocation}>
              Find Location
            </Button>
          </div>
        }
        image='Home'
      >
        <div className='flex w-full'>
          <Text.BodyLarge>
            <p>
              For God so loved the world that He gave His only begotten Son, that whoever believes
              in Him should not perish but have everlasting life
              {' - '}
              <a
                href='https://bible.com/bible/114/jhn.3.16.NKJV'
                target='_blank'
                rel='noreferrer'
                className='hover:border-b-2 border-b-rose-600 transition-all'
              >
                <Text.Gradient>John 3:16</Text.Gradient>
              </a>
            </p>
          </Text.BodyLarge>
        </div>
      </Hero>
      <GoodNewsBanner />
      <WeBelieve />
      <Media />
      <OurActivities />
      <AnnouncementsPreview />
      <Location onContainerRef={setLocationRef} />
    </Page>
  )
}
